export const CHANGE_PAGE_STATE_HOME = "CHANGE_PAGE_STATE_HOME";
export const CHANGE_PAGE_STATE_WORKS = "CHANGE_PAGE_STATE_WORKS";
export const CHANGE_PAGE_STATE_CONTACT = "CHANGE_PAGE_STATE_CONTACT";